<div class="station-tile {{style}}"
    [ngClass]="{ 'selected' : selected, 'suspended' : suspended , 'disabled': disabled}"
    [ngStyle]="{ 'height.px': height }"
    >
    <sc-flex [fitHeight]="true" [stretchContent]="true">
        <sc-flex-fitting-content>
            <ng-content></ng-content>
        </sc-flex-fitting-content>
    </sc-flex>
</div>